import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../utils/store';
import User from '../../../models/User';

export interface CreateAccountModalState {
    isOpen: boolean;
    vehicle?: User;
}

const initialState: CreateAccountModalState = {
    isOpen: false,
};

export const slice = createSlice({
    name: 'createAccountModal',
    initialState,
    reducers: {
        setOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setUser: (state, action: PayloadAction<User>) => {
            state.vehicle = action.payload;
        },
    },
});

export const { setOpen, setUser } = slice.actions;
export const actions = slice.actions;

export const selectIsOpen = (state: RootState) =>
    state.createAccountModal.isOpen;
export const selectAccount = (state: RootState) =>
    state.createAccountModal.vehicle;

export default slice.reducer;
